var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import React, { useMemo } from "react";
import { Grid, Icon, useLinkResolver } from "../../../components";
import { ActionButton, Table, TableWrapper, TableCell, TableRow, TableHeadlineCell, TableHeaderCell, TableRecommendedCell, TableActionCell, EmptyCell, TableAnnotationCell, TableSubHeaderCell, SpecialOfferWrapper } from "./BenefitsTable.styled";

var isEmpty = function isEmpty(list) {
  return list.filter(function (value) {
    return value === null;
  }).length === list.length;
};

var TableContent = function TableContent(_a) {
  var content = _a.content,
      Wrapper = _a.Wrapper;

  if (typeof content !== "string") {
    return React.createElement(Wrapper, null, content);
  }

  return React.createElement(Wrapper, {
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};

var BenefitsTable = function BenefitsTable(_a) {
  var _b = _a.packages,
      packages = _b === void 0 ? [] : _b,
      footer = _a.footer,
      _c = _a.features,
      features = _c === void 0 ? [] : _c,
      action = _a.action,
      anchor = _a.anchor,
      props = __rest(_a, ["packages", "footer", "features", "action", "anchor"]);

  var resolveAction = useLinkResolver().resolveAction;
  var rows = useMemo(function () {
    var list = features.reduce(function (acc, crr) {
      var row = !!acc.length ? __spreadArray([], acc, true) : new Array(crr.list.length).fill([]);
      crr.list.forEach(function (el, idx) {
        if (!!el.name) {
          row[idx] = __spreadArray(__spreadArray([], row[idx], true), [React.createElement(Grid.Box, {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }, React.createElement(Icon, {
            name: el.name,
            width: el.size,
            color: el.color
          }))], false);
        } else {
          row[idx] = __spreadArray(__spreadArray([], row[idx], true), [el], false);
        }
      });
      return row;
    }, []);
    return list.map(function (elm, idx) {
      return __spreadArray([packages[idx]], elm, true);
    });
  }, [features, packages]);
  var details = useMemo(function () {
    return features.reduce(function (prev, crr) {
      return {
        titles: __spreadArray(__spreadArray([], prev.titles, true), [crr.title || null], false),
        recommendations: __spreadArray(__spreadArray([], prev.recommendations, true), [crr.isRecommended || null], false),
        subtitles: __spreadArray(__spreadArray([], prev.subtitles, true), [crr.subtitle || null], false),
        actions: __spreadArray(__spreadArray([], prev.actions, true), [crr.footer || null], false),
        annotations: __spreadArray(__spreadArray([], prev.annotations, true), [crr.annotation || null], false),
        specialOffer: __spreadArray(__spreadArray([], prev.specialOffer, true), [crr.specialOffer || null], false)
      };
    }, {
      titles: [null],
      subtitles: [null],
      recommendations: [null],
      actions: [null],
      annotations: [null],
      specialOffer: [null]
    });
  }, [features]);
  var columnWidth = useMemo(function () {
    if (details.titles.length > 2) {
      return (window.innerWidth / 2 - 32) * details.titles.length;
    }

    return window.innerWidth / 2 * details.titles.length;
  }, [details]);
  var columnCount = useMemo(function () {
    return details.titles.length;
  }, [details]);
  return React.createElement(Grid.Container, __assign({
    id: anchor
  }, props), React.createElement(TableWrapper, null, React.createElement(Table, {
    columnWidth: columnWidth,
    columnCount: columnCount
  }, React.createElement(TableRow, null, details.recommendations.map(function (value) {
    return !!value ? React.createElement(TableRecommendedCell, null, "PRODUKT REKOMENDOWANY") : React.createElement(EmptyCell, null);
  })), React.createElement(TableRow, null, details.titles.map(function (value, idx) {
    return value === null ? React.createElement(EmptyCell, null) : React.createElement(TableHeaderCell, null, React.createElement(TableContent, {
      content: value,
      Wrapper: function Wrapper(props) {
        return React.createElement("span", __assign({}, props, {
          style: {
            display: "block",
            padding: !!details.specialOffer[idx] ? "0 50px 0 0" : "unset"
          }
        }));
      }
    }), details.subtitles[idx] && React.createElement(TableContent, {
      content: details.subtitles[idx],
      Wrapper: function Wrapper(props) {
        return React.createElement(TableSubHeaderCell, __assign({}, props, {
          style: {
            padding: !!details.specialOffer[idx] ? "0 50px 0 0" : "unset"
          }
        }));
      }
    }), details.specialOffer[idx] && React.createElement(SpecialOfferWrapper, null, React.createElement("p", null, details.specialOffer[idx].text), React.createElement("a", {
      href: details.specialOffer[idx].link,
      target: "_blank",
      rel: "noreferrer"
    }, details.specialOffer[idx].textLink)));
  })), rows.map(function (row) {
    return React.createElement(TableRow, null, row.map(function (value, idx) {
      return idx === 0 ? React.createElement(TableContent, {
        content: value,
        Wrapper: TableHeadlineCell
      }) : React.createElement(TableContent, {
        content: value,
        Wrapper: TableCell
      });
    }));
  }), React.createElement(TableRow, {
    isEmpty: isEmpty(details.actions)
  }, details.actions.map(function (value) {
    return value === null ? React.createElement(EmptyCell, null) : React.createElement(TableActionCell, null, React.createElement(ActionButton, {
      onClick: function onClick() {
        return resolveAction(value.link);
      },
      isPrimary: true
    }, value.text));
  })), React.createElement(TableRow, {
    isEmpty: isEmpty(details.annotations)
  }, details.annotations.map(function (text) {
    return text === null ? React.createElement(EmptyCell, null) : React.createElement(TableAnnotationCell, null, React.createElement("div", null, React.createElement(Icon, {
      name: "Info"
    }), React.createElement(TableContent, {
      content: text,
      Wrapper: function Wrapper(props) {
        return React.createElement("span", __assign({}, props));
      }
    })));
  })), action && React.createElement(TableRow, null, React.createElement(EmptyCell, null), React.createElement(TableActionCell, {
    colSpan: details.titles.length - 1
  }, React.createElement(ActionButton, {
    onClick: function onClick() {
      return resolveAction(action.link);
    },
    isPrimary: true
  }, React.createElement(TableContent, {
    content: action.text,
    Wrapper: function Wrapper(props) {
      return React.createElement("span", __assign({}, props));
    }
  })))), footer && React.createElement(TableRow, null, React.createElement(EmptyCell, null), React.createElement(TableAnnotationCell, {
    colSpan: details.titles.length - 1
  }, React.createElement("div", null, React.createElement(Icon, {
    name: "Info"
  }), React.createElement(TableContent, {
    content: footer.text,
    Wrapper: function Wrapper(props) {
      return React.createElement("span", __assign({}, props));
    }
  }), footer.link && React.createElement("a", {
    href: footer.link
  }, "Czytaj wi\u0119cej"), footer.moreText && React.createElement(TableContent, {
    content: footer.moreText,
    Wrapper: function Wrapper(props) {
      return React.createElement("span", __assign({}, props));
    }
  })))))));
};

export default BenefitsTable;